/*
Controller: Bundles

Operations:
  getBundles
  createBundle
  checkisBundleUnique
  getCountMetaDataOfFamiliesByFoundries
  delete
  getBundle
  updateBundle
  changeMode
  uploadBundleImage
  deleteBundleImage
*/
var Api = require('../config')
var BundleDef = require('../definitions/Bundle')
var BundleModeDef = require('../definitions/BundleMode')
var AssetUploadRequestDef = require('../definitions/AssetUploadRequest')

var Bundles = (function () {
  /*
  Operation: getBundles
  Query existing bundles
  Parameters:
    type: filter by type, possible values: &#39;draft&#39;, &#39;published&#39;


    page: page number, starting with 1
    perPage: number of items per page, max 50
    sortBy: field to sort by, possible values: &#39;created_at&#39;,&#39;updated_at&#39;
    sortDirection: direction to sort by, asc or desc
    mode: mode active, in_active, expired
  Responses:
    HTTP 200: List of bundles
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getBundlesBundles (type, foundries, search, page, perPage, sortBy, sortDirection, mode) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['type'] = type
      parameters['foundries'] = foundries
      parameters['search'] = search
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      parameters['mode'] = mode
      var path = '/bundles'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createBundle
  Create Bundle
  Parameters:
    bodyRequest: Bundle object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Create Bundle API failed
    HTTP 404: Bundle Not Found
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function createBundleBundles (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        BundleDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/bundles'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: checkisBundleUnique
  Check bundle is unique or not
  Parameters:
    bundleName: Name of the bundle
    bundleId: Bundle Id
  Responses:
    HTTP 200: Bundle is Unique or not
    HTTP 403: Operation not permitted
  */
  function checkisBundleUniqueBundles (bundleName, bundleId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!bundleName) {
          throw new Error('bundleName: Missing parameter')
        }
        if (bundleName && !(typeof bundleName === 'string')) {
          throw new Error('bundleName: Wrong type: Got "' + (typeof bundleName) + '", but expected: "string"')
        }
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['bundleId'] = bundleId
      var path = '/bundles/checkUnique/{bundleName}'
      path = path.replace('{' + 'bundleName' + '}', bundleName)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getCountMetaDataOfFamiliesByFoundries
  Get count metadata of families by foundries for bundles
  Parameters:
    foundryIds: Foundry ids with multiple ids separated by comma
    search: search string
    page: page number, starting with 1
    perPage: number of items per page, max 50
  Responses:
    HTTP 200: Total count of bundle families
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getCountMetaDataOfFamiliesByFoundriesBundles (foundryIds, search, page, perPage) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryIds) {
          throw new Error('foundryIds: Missing parameter')
        }
        if (foundryIds && !(typeof foundryIds === 'string')) {
          throw new Error('foundryIds: Wrong type: Got "' + (typeof foundryIds) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['foundryIds'] = foundryIds
      parameters['search'] = search
      parameters['page'] = page
      parameters['perPage'] = perPage
      var path = '/bundles/count-metadata-families-by-foundries'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: delete
  Delete bundles draft
  Parameters:
    bundleId: Id of the bundle
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete bundle
    HTTP 403: Operation not permitted
    HTTP 404: Bundle not found
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function deleteBundles (bundleId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/bundles/{bundleId}'
      path = path.replace('{' + 'bundleId' + '}', bundleId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getBundle
  Get an existing Bundle
  Parameters:
    bundleId: id of the bundle
  Responses:
    HTTP 200: Valid response
    HTTP 400: Bundle Update Failed
    HTTP 403: Operation Not Permitted
    HTTP 404: Bundle Not Found
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getBundleBundles (bundleId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/bundles/{bundleId}'
      path = path.replace('{' + 'bundleId' + '}', bundleId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateBundle
  Update an existing Bundle
  Parameters:
    bundleId: id of the bundle
    bodyRequest: Bundle Object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Bundle Update Failed
    HTTP 403: Operation Not Permitted
    HTTP 404: Bundle Not Found
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function updateBundleBundles (bundleId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
        BundleDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/bundles/{bundleId}'
      path = path.replace('{' + 'bundleId' + '}', bundleId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: changeMode
  Change mode of the bundle
  Parameters:
    bundleId: id of the bundle
    bodyRequest: Bundle Object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Bundle Change Mode Failed
    HTTP 403: Operation Not Permitted
    HTTP 404: Bundle Not Found
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function changeModeBundles (bundleId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
        BundleModeDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/bundles/{bundleId}/change-mode'
      path = path.replace('{' + 'bundleId' + '}', bundleId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: uploadBundleImage
  Upload bundle image to the platform
  Parameters:
    bundleId: Id of the bundle

  Responses:
    HTTP 200: Successful upload
    HTTP 400: Upload failed
    HTTP 403: Operation not permitted
    HTTP 413: Uploaded file too large
    HTTP 415: Wrong file type
  */
  function uploadBundleImageBundles (bundleId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
        AssetUploadRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/bundles/{bundleId}/image'
      path = path.replace('{' + 'bundleId' + '}', bundleId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteBundleImage
  Delete bundle image
  Parameters:
    imageId: Id of bundle image
    bundleId: Id of the bundle
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete bundle image
    HTTP 403: Operation not permitted
    HTTP 404: Image not found
  */
  function deleteBundleImageBundles (imageId, bundleId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!imageId) {
          throw new Error('imageId: Missing parameter')
        }
        if (imageId && !(typeof imageId === 'string')) {
          throw new Error('imageId: Wrong type: Got "' + (typeof imageId) + '", but expected: "string"')
        }
        if (!bundleId) {
          throw new Error('bundleId: Missing parameter')
        }
        if (bundleId && !(typeof bundleId === 'string')) {
          throw new Error('bundleId: Wrong type: Got "' + (typeof bundleId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/bundles/{bundleId}/image/{imageId}'
      path = path.replace('{' + 'imageId' + '}', imageId)
      path = path.replace('{' + 'bundleId' + '}', bundleId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getBundles'] = getBundlesBundles
  ret['createBundle'] = createBundleBundles
  ret['checkisBundleUnique'] = checkisBundleUniqueBundles
  ret['getCountMetaDataOfFamiliesByFoundries'] = getCountMetaDataOfFamiliesByFoundriesBundles
  ret['delete'] = deleteBundles
  ret['getBundle'] = getBundleBundles
  ret['updateBundle'] = updateBundleBundles
  ret['changeMode'] = changeModeBundles
  ret['uploadBundleImage'] = uploadBundleImageBundles
  ret['deleteBundleImage'] = deleteBundleImageBundles
  return ret
})()

module.exports = Bundles
